var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"pages","title":"Page","columns":"2","submit":_vm.submit,"schema":[
    [
      {
        component: 'FInput',
        key: 'title',
        label: 'Title',
        column: 1
      },
      {
        component: 'FInput',
        key: 'subtitle',
        label: 'Subtitle',
        column: 1
      }
    ],
    [
      {
        component: 'FInput',
        key: 'slug',
        label: 'Slug',
        column: 1
      },
      {
        component: 'FInput',
        key: 'section',
        label: 'Section',
        column: 1
      }
    ],
    {
      component: 'FEditor',
      key: 'content',
      label: 'Content',
      column: 1
    },
    {
      component: 'FEditor',
      key: 'ksp_content',
      label: 'KSP Content',
      column: 1
    },
    {
      component: 'FInput',
      key: 'ksp_bg_hex',
      label: 'KSP Panel Background Colour (Hex)',
      column: 1
    },
    [
      {
        component: 'FInput',
        key: 'ksp_button_title',
        label: 'KSP Button Title',
        column: 1
      },
      {
        component: 'FInput',
        key: 'ksp_button_url',
        label: 'KSP Button URL',
        column: 1
      }
    ],
    {
      component: 'FEditor',
      key: 'overview',
      label: 'Overview',
      column: 1
    },
    {
      component: 'FCheckboxList',
      key: 'related_tours',
      label: 'Related Tours',
      items: _vm.tours,
      column: 1,
    },
    {
      component: 'FSelect',
      key: 'destination_id',
      label: 'Destination',
      items: _vm.destinations,
      column: 1,
    },
    {
      component: 'FMediaPicker',
      key: 'media_id',
      label: 'Featured Image',
      column: 2,
    },
    {
      component: 'FMediaPicker',
      key: 'banner_id',
      label: 'Banner',
      column: 2,
    },
    {
      component: 'FMediaPicker',
      key: 'overview_image_id',
      label: 'Overview Image',
      column: 2,
    },
    {
      component: 'FInput',
      key: 'seo_title',
      label: 'SEO Title (max 80 chars)',
      column: 1
    },
    {
      component: 'FTextarea',
      key: 'seo_description',
      label: 'SEO Description (max 150 chars)',
      column: 1
    },
    {
      component: 'FInput',
      key: 'seo_keywords',
      label: 'SEO Keywords (max 5 sentense/words, separated by comma)',
      column: 1
    } ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }